import { faBell, faCakeCandles, faCandyCane, faChampagneGlasses, faFireBurner, faFireExtinguisher, faFireFlameCurved, faGifts, faHammer, faPeopleGroup, faScrewdriverWrench, faTruckMedical } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Toast, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function PopUp() {
    const [showToast, setShowToast] = useState(false);
    const [isRinging, setIsRinging] = useState(true);
    const [isBellLoaded, setIsBellLoaded] = useState(false);
    const navigate=useNavigate();
    const toggleToast = () => {
      setShowToast(!showToast);
      setIsRinging(false); // Stop the ringing animation when toast is shown
    };
  
    useEffect(() => {
      // Simulate loading the bell icon and sliding in
      setTimeout(() => {
        setIsBellLoaded(true);
      }, 1000);
    }, []);
  
    return (
      <div className={`side-toast-container ${isBellLoaded ? 'bell-loaded' : ''}`}>
        {/* The bell icon with sliding and continuous ringing animation */}
        <div className='poppi'>
        <button className={`bell-button ${isRinging ? 'ring' : ''}`} onClick={toggleToast}>
          {isBellLoaded && <FontAwesomeIcon icon={faBell} />}&nbsp;Neu!
        </button>
      
        </div>
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          className="side-toast"
          animation={false} // Disable built-in Bootstrap animations
        >
          <Toast.Header closeButton={false}>
            <strong className="mr-auto">Updates</strong>
          </Toast.Header>
          <Toast.Body>
            {/* Add your content for displaying the newest posts here */}
            <ul>
              <a type="button" className="clicky" onClick={()=>{navigate("/reportPage/reportDetails/20240209180057")}}><FontAwesomeIcon icon={faPeopleGroup} />&nbsp;Jahreshauptversammlung OW Kubschütz&nbsp;<FontAwesomeIcon icon={faPeopleGroup} /></a>
              <a type="button" className="clicky" onClick={()=>{navigate("reportPage/reportDetails/20240119113670")}}><FontAwesomeIcon icon={faTruckMedical} />&nbsp;Update zum neuen TLF&nbsp;<FontAwesomeIcon icon={faTruckMedical} /></a>
             

              {/* Add more posts as needed */}
            </ul>
          </Toast.Body>
        </Toast>
      </div>
    );
  }

export default PopUp;
